import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bottom" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "bottom-box flex-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "msg" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "line"
}

import { useI18n } from 'vue-i18n';
import { showUrlPopup } from '@/components/UrlPopup';
import { getOS } from '@/common/ts/utils';
import { computed, ref } from 'vue';
import { originObj } from '@/config/index';



export default /*@__PURE__*/_defineComponent({
  __name: 'BottomMsg',
  setup(__props) {

const { t, locale } = useI18n();



const os = getOS()

const URL_TYPES = ['terms', 'privacy', 'refund'];
const urlList = computed(() =>
    URL_TYPES.map(type => ({
        type, // 作为更稳定的 key
        title: t(`buttons.${type}`),
        url: `/policyLinks/${type}/${locale.value}.html`
    }))
);


const toUrl = (url: string) => {
    // window.open(url, '_blank');
    if (['windows', 'mac'].includes(os)) {
        window.open(url, '_blank');
    } else {
        showUrlPopup({
            url,
            style: {
                width: '80%',
                height: '80%',
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                borderRadius: '10px',
            }
        })
    }
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "logo",
          src: _unref(originObj)?.logo?.bottom || '',
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(urlList.value, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.type
              }, [
                _createElementVNode("span", {
                  class: "link",
                  onClick: ($event: any) => (toUrl(item.url))
                }, _toDisplayString(item.title), 9, _hoisted_6),
                (index !== urlList.value.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "|"))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", null, " NEW LINK GAMES LIMITED ", -1)),
          _createElementVNode("div", null, _toDisplayString(_unref(t)('common.companyAddress')) + "：RM 1307,13/F.,KENBO COMMERCIAL BUILDING,3.HONG KONG ", 1),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, " COPYRIGHT © 2026 NEW LINK GAMES ", -1)),
          _createElementVNode("div", null, _toDisplayString(_unref(t)('common.email')) + "：service@newlinkgames.com " + _toDisplayString(_unref(t)('common.contactPhone')) + "：+886 44430701 ", 1)
        ])
      ])
    ])
  ]))
}
}

})